// extracted by mini-css-extract-plugin
export var carouselList = "style-module--carousel-list--d2982";